"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.versions = void 0;
;
exports.versions = {
  version: '3.0.73',
  name: 'lingo2-api-models',
  versionDate: '2025-07-29T15:13:59.456Z',
  description: 'Shared api models library',
  gitCommitHash: 'g7240755',
  gitCommitDate: '2025-07-29T15:13:33.000Z',
  versionLong: '3.0.73-g7240755',
  gitTag: 'v3.0.72'
};
exports.default = exports.versions;
